import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block-content" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "block-body" }
const _hoisted_4 = { class: "block-list" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["onUpdate:modelValue", "id"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", {
      class: "block-desc",
      innerHTML: _ctx.text
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crit, (csiParam) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "block-item",
            key: csiParam.csiParamId
          }, [
            _createElementVNode("p", {
              class: "block-subtitle",
              innerHTML: csiParam.paramName
            }, null, 8, _hoisted_5),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(csiParam.criterias, (criterion) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "block-field",
                key: criterion.id
              }, [
                _createElementVNode("p", {
                  class: "block-field__title",
                  innerHTML: criterion.name
                }, null, 8, _hoisted_6),
                (_ctx.csiScale === 'TEN_POINTS')
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      "onUpdate:modelValue": ($event: any) => ((criterion.score) = $event),
                      class: "select",
                      id: criterion.csiCriteriaId,
                      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeSelect && _ctx.changeSelect(...args)))
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (score, index) => {
                        return _createElementVNode("option", {
                          key: score,
                          value: index
                        }, _toDisplayString(index), 9, _hoisted_8)
                      }), 64))
                    ], 40, _hoisted_7)), [
                      [_vModelSelect, criterion.score]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.csiScale === 'FIVE_POINTS')
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 1,
                      "onUpdate:modelValue": ($event: any) => ((criterion.score) = $event),
                      class: "select",
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeSelect && _ctx.changeSelect(...args)))
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (score, index) => {
                        return _createElementVNode("option", {
                          key: score,
                          value: index
                        }, _toDisplayString(index), 9, _hoisted_10)
                      }), 64))
                    ], 40, _hoisted_9)), [
                      [_vModelSelect, criterion.score]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.csiScale === 'BOOLEAN')
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 2,
                      "onUpdate:modelValue": ($event: any) => ((criterion.score) = $event),
                      class: "select",
                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeSelect && _ctx.changeSelect(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booleanPointScore, (score) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: score.score,
                          value: score.score
                        }, _toDisplayString(score.name), 9, _hoisted_12))
                      }), 128))
                    ], 40, _hoisted_11)), [
                      [_vModelSelect, criterion.score]
                    ])
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ]))
}